import firebase from 'firebase/app';
import 'firebase/firestore';
import { Plan } from './types';

const COLLECTION = 'departPlans';

function col() {
  return firebase.firestore().collection(COLLECTION);
}

function withoutUndefined<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(item => withoutUndefined(item)) as any;
  }
  if (value && typeof value === 'object') {
    return Object.entries(value).reduce((acc, [key, entry]) => {
      if (entry !== undefined) {
        (acc as any)[key] = withoutUndefined(entry);
      }
      return acc;
    }, {} as any);
  }
  return value;
}

export function watchPlans(cb: (plans: Plan[]) => void, onError?: (err: Error) => void): () => void {
  return col().orderBy('updatedAt', 'desc').onSnapshot(
    snap => cb(snap.docs.map(d => ({ id: d.id, ...(d.data() as Omit<Plan, 'id'>) }))),
    err => { console.error('watchPlans error:', err); onError && onError(err); },
  );
}

export async function savePlan(plan: Plan): Promise<Plan> {
  const savedPlan = { ...plan, updatedAt: Date.now() };
  const data = withoutUndefined(savedPlan);
  delete (data as any).id;
  await col().doc(plan.id).set(data);
  return savedPlan;
}

export async function deletePlan(planId: string): Promise<void> {
  await col().doc(planId).delete();
}
